import { Tag, Typography, Space } from 'antd';
import { useTranslation } from 'react-i18next';

export const tagRegex = /^(?<key>[a-zA-Z]+)::(?<value>.+)$/;

export type RoleTagsProps = { tags: string[] };

const colorMap = {
    module: 'cyan',
    router: 'volcano',
    language: 'lime',
    user: 'magenta',
    role: 'purple',
    userGroup: 'red',
    dealer: 'gold',
};

export const RoleTags = ({ tags }: RoleTagsProps) => {
    const { t } = useTranslation(['roleDetails']);

    return (
        <>
            {tags.map(tag => {
                const { key, value } = tag.match(tagRegex).groups;
                const label = t(`roleDetails:permissionDrawer.tags.${key}`);

                return (
                    <Tag key={tag} color={colorMap[key] || 'default'}>
                        <Space>
                            <Typography.Text style={{ color: 'inherit' }} strong>
                                {label}:
                            </Typography.Text>
                            <Typography.Text style={{ color: 'inherit' }}>{value}</Typography.Text>
                        </Space>
                    </Tag>
                );
            })}
        </>
    );
};

export default RoleTags;
